"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Compute = void 0;
const evaluate_1 = require("../../evaluate");
const infer_1 = require("../../infer");
const stmt_1 = require("../../stmt");
const value_1 = require("../../value");
class Compute extends stmt_1.Stmt {
    constructor(exp, span) {
        super();
        this.exp = exp;
        this.span = span;
    }
    execute(mod) {
        return __awaiter(this, void 0, void 0, function* () {
            const inferred = (0, infer_1.infer)(mod, mod.ctx, this.exp);
            const value = (0, evaluate_1.evaluate)(mod.env, inferred.core);
            return (0, value_1.formatTypedValue)(mod, mod.ctx, (0, value_1.TypedValue)(inferred.type, value));
        });
    }
}
exports.Compute = Compute;
//# sourceMappingURL=Compute.js.map